<template>
  <div
    class="data-block d-flex flex-row justify-content-start align-items-center i-pt-3 i-pb-3"
  >
    <div class="icon-container">
      <i-icon
        :symbol="leftIcon"
        class="data-icon i-text-neutral-90 i-mr-8"
        :size="16"
      ></i-icon>
    </div>
    <div class="content d-flex flex-column">
      <div class="label i-text-body-3 i-text-neutral-110">{{ label }}</div>
      <div
        v-if="value || value === 0"
        class="value i-text-button-3 i-text-neutral-120"
      >
        {{ value }}
      </div>
      <slot v-else></slot>
    </div>
    <help-article-link
      v-if="helpLink"
      :dark="true"
      :help-article="helpLink"
      class="help-link"
    />
    <div
      v-if="hasCopyText"
      class="right-icon-container i-ml-2"
      @click="copyText"
      @mouseenter="hovering = 'copy'"
      @mouseleave="hovering = ''"
    >
      <i-icon
        symbol="small-edit-copy"
        :class="{
          'i-text-neutral-70': hovering !== 'copy',
          'i-text-neutral-90': hovering === 'copy',
        }"
        class="copy-icon hover-icon"
        :size="16"
      ></i-icon>
      <input ref="hiddenInput" :value="value" class="hidden-copy-input" />
    </div>
    <div
      v-if="rightIcon"
      class="right-icon-container i-ml-2"
      @click="onRightIconClick"
      @mouseenter="hovering = 'right'"
      @mouseleave="hovering = ''"
    >
      <i-icon
        :symbol="rightIcon"
        :class="{
          'i-text-neutral-70': hovering !== 'right',
          'i-text-neutral-90': hovering === 'right',
        }"
        class="right-icon hover-icon"
        :size="16"
      ></i-icon>
    </div>
  </div>
</template>

<script>
import { iIcon, showToast } from '@inscribe/signal';
import HelpArticleLink from '@/V2/documents/HelpArticleLink';

export default {
  components: { iIcon, HelpArticleLink },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    leftIcon: {
      type: String,
      default: null,
    },
    rightIcon: {
      type: String,
      default: null,
    },
    helpLink: {
      type: String,
      default: null,
    },
    hasCopyText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovering: '',
    };
  },

  methods: {
    copyText() {
      const copyInput = this.$refs.hiddenInput;
      if (copyInput) {
        copyInput.select();
        copyInput.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(copyInput.value);
        showToast({
          text: `Text copied to Clipboard`,
        });
        this.$emit('onTextCopy');
      }
    },
    onRightIconClick() {
      this.$emit('onRightIconClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.data-block {
  width: 100%;
  display: flex;

  .right-icon-container {
    width: 16px;
  }

  &:hover {
    .help-link,
    .copy-icon,
    .right-icon {
      display: block !important;
    }
  }

  .help-link {
    :deep(svg) {
      color: $light-neutral-70 !important;
    }
  }

  .copy-icon,
  .right-icon {
    cursor: pointer;
  }

  .help-link,
  .copy-icon,
  .right-icon {
    display: none !important;
  }
  .content {
    flex: 1;
  }

  .hidden-copy-input {
    display: none;
  }
}
</style>
